__turbopack_context__.v({
  "ns_tab-image-mobile-bg": "AcfTabs-module-scss-module__ki9CWW__ns_tab-image-mobile-bg",
  "tab": "AcfTabs-module-scss-module__ki9CWW__tab",
  "tab-body": "AcfTabs-module-scss-module__ki9CWW__tab-body",
  "tab-card": "AcfTabs-module-scss-module__ki9CWW__tab-card",
  "tab-icon": "AcfTabs-module-scss-module__ki9CWW__tab-icon",
  "tab-image": "AcfTabs-module-scss-module__ki9CWW__tab-image",
  "tab-list": "AcfTabs-module-scss-module__ki9CWW__tab-list",
  "tabs": "AcfTabs-module-scss-module__ki9CWW__tabs",
});
